import { t } from 'i18next';
import { safeCharacterName } from '../../../../../../shared/common/utils';
import { namedRoutes, resolveRoutePath } from '../../bundles/routes';
import { RecruitmentProfileBadge } from '../../shared/recruitment/components/RecruitmentProfileBadge';
import { Link } from '../../../../../../shared/frontend/components/link';
import { SpecIcon } from '../../../../../../shared/frontend/scripts/wow/components/SpecIcon';
import { StreamTooltipContent } from '../../../../../../shared/frontend/components/presentational/streamPreview';
import { ComplexTooltip } from '../../../../../../shared/frontend/components/presentational/tooltip';
import { useSiteMeta } from '../../../../../../shared/frontend/scripts/selectors/global';
import { TSiteMetaClientState } from '../../libs/store';
import { IRaidEncounterRosterMemberCharacter } from '../../../../shared/types/raidTypes';
import { Stack } from '../../../../../../shared/frontend/components/stack/Stack';
import { Avatar } from '../../../../../../shared/frontend/components/avatar/Avatar';

interface IProps {
  character: IRaidEncounterRosterMemberCharacter;
}

export const CharacterRosterName = ({ ...props }: IProps) => {
  const character = props.character;
  const siteMeta = useSiteMeta() as TSiteMetaClientState;

  const hasHeroSubTree = character.talentLoadout && character.talentLoadout.heroSubTreeId;

  const heroSubTree = hasHeroSubTree ? siteMeta.heroSubTrees[character.talentLoadout!.heroSubTreeId] : null;

  return (
    <>
      <ComplexTooltip
        placement="top"
        tooltip={
          <div>
            <div>
              {t(`game:specs.${character.class.slug}.${character.spec.slug}.name`)} {t(`game:classes.${character.class.slug}.name`)}
            </div>
            {heroSubTree && (
              <div>
                <i className="text-muted">{heroSubTree.name}</i>
              </div>
            )}
            {character.stream && <StreamTooltipContent type="twitch" stream={character.stream} count={1} />}
          </div>
        }
        className="d-inline-block"
      >
        <Stack alignItems="center">
          <Avatar border size={18} contentBox className="rio-shadow--small">
            <SpecIcon size={18} class={character.class.slug} spec={character.spec.slug} />
          </Avatar>
          <Link
            to={resolveRoutePath(namedRoutes.CharacterDetails, {
              region: character.region.slug,
              realm: character.realm.slug,
              character: character.name
            })}
            className={`class-color--${character.class.id} ${character.stream ? 'streaming-now' : ''} character-name`}
          >
            {safeCharacterName(character.name)}
          </Link>
        </Stack>
      </ComplexTooltip>
      {character.recruitmentProfiles && character.recruitmentProfiles.length > 0 && (
        <RecruitmentProfileBadge
          link={resolveRoutePath(namedRoutes.CharacterRecruitmentPage, {
            region: character.region.slug,
            realm: character.realm.slug,
            character: character.name
          })}
          className="slds-m-left--xx-small"
          profile={character.recruitmentProfiles[0].recruitment_profile_id}
        />
      )}
    </>
  );
};
